export default "__VITE_ASSET__BIy1rjia__"